//src/services/userManagementApi.js
import axios from "axios";
import { USERMGMT_URL } from "../utils/envConfig";

const userManagementApi = axios.create({
  baseURL: USERMGMT_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add JWT only to requests made through this User Management client
userManagementApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default userManagementApi;